<template>
  <div v-if="open" class="inv-backdrop" @click.self="$emit('close')">
    <div class="inv-modal" :class="{ 'inv-modal-lg': large }" :style="modalStyle">
      <div class="inv-modal-header">
        <h5 class="inv-modal-title">{{ title }}</h5>
        <button type="button" class="inv-modal-close" @click="$emit('close')" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="inv-modal-body">
        <slot />
      </div>
      <div v-if="$slots.footer" class="inv-modal-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InvModal",
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, required: true },
    maxWidth: { type: String, default: "" },
    large: { type: Boolean, default: false },
  },
  computed: {
    modalStyle() {
      return this.maxWidth ? { maxWidth: this.maxWidth } : {};
    },
  },
  watch: {
    open(v) {
      document.body.style.overflow = v ? "hidden" : "";
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
};
</script>
